import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./history.css";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".page-header");
  const images = header.querySelectorAll(".grid-image");

  const speeds = [0.2, 0.7, 0.3, 0.4, 0.2, 0.4, 0.3, 0.7];

  gsap.to(images, {
    yPercent: (index) => {
      const speed = speeds[index];
      return speed * -100;
    },
    duration: (index) => {
      const speed = speeds[index];
      return speed;
    },
    scrollTrigger: {
      trigger: header,
      markers: false,
      scrub: 1.5,
      start: "top top",
      end: "bottom center",
    },
  });
});
